<template>
<span class="timer">
    {{distanceFormatted}}
</span>
</template>

<script>
import { format, addSeconds, formatDistanceStrict, isBefore, subSeconds, differenceInDays } from 'date-fns';
import {ru, en, tr, es, pt, de, fr, id, pl} from 'date-fns/locale';

const locales = {ru, en, tr, es, pt, de, fr, id, pl};

export default {
    data() {
        return {
            start: new Date(0,0),
            end: null
        };
    },
    computed: {
        distanceFormatted() {
            return [
                differenceInDays(this.end, this.start) > 0 ? 
                    formatDistanceStrict(this.end, this.start, {
                        unit: 'day',
                        roundingMethod: 'floor',
                        locale: locales[this.locale],
                    }) + ' ' :
                    '',
                format(this.end, 'HH:mm:ss')
            ].join('');
        }
    },
    methods: {
        
    },
    props: ['duration','locale'],
    watch: {
        
    },
    mounted() {
        
    },
    created() {
        if (this.duration > 0) {
            this.end = addSeconds(this.start, this.duration);
            setInterval(() => {
                if (isBefore(this.start, this.end)) {
                    this.end = subSeconds(this.end, 1);
                }
            }, 1000);
        } else {
            this.end = this.start;
        }
    }
}
</script>

<style>
    
</style>